/**
 * The product name as users see it (ADR 380). Everything user-facing on the
 * web reads it from here: the tab title and PWA manifest (vite.config.ts
 * stamps them at build), the topbar lockup's alt text, and every locale
 * string through the `{{product}}` default variable in i18n.ts.
 *
 * Internal names stay as they are — package ids, the realm, the MCP server,
 * repo paths — only what a user reads changes when this constant does.
 * The lockup, marks and icons are files rendered in place by
 * assets/brand/falcon/render.py from the design pack (ADR 386).
 */
export const PRODUCT_NAME = "Falcon";

/** pt-BR one-liner for the tab description and the PWA manifest. */
export const PRODUCT_DESCRIPTION = `${PRODUCT_NAME} — monitoramento em tempo real do armazém`;
